import React, { Component } from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import _ from "lodash";
import {
  selectDashboardMenu,
  selectedRevealMenuIcon,
} from "DashboardMenuAction";
import AppIcons from "AppIcons";
import { withRouter } from "react-router-dom";
import { NEW_IMAGE_PATH, DEVELOPMENT_TYPE } from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import { Tooltip, OverlayTrigger, Button } from "react-bootstrap";

class MenuIcon extends Component {
  constructor(props) {
    super(props);
    this.state = { hovered: false };
  }

  componentDidMount() {}

  onMenuClick = () => {
    // debugger;
    var bsClass = _.lowerCase(this.props.menuItem.bsClass);
    var path = `/dashboard/${bsClass}`;

    let { siteDetails } = this.props;
    let siteURL = "";
    if (
      siteDetails &&
      siteDetails.resource &&
      !_.isEmpty(siteDetails.resource) &&
      siteDetails.resource[0].website_subdomain
    ) {
      siteURL =
        "https://" + siteDetails.resource[0].website_subdomain + ".eventify.io";
    }

    if (bsClass === "general") {
      path = `/dashboard`;
    }
    // This is used to redirect to dashbord sub-menu directly on click of these menu
    if (bsClass === "website") {
      // path=`/dashboard/${bsClass}/dashboard`;
      // path=`/dashboard/${bsClass}/wizard`;
      path = `/dashboard/${bsClass}/`;

      if (siteURL === "") {
        path = `/dashboard/${bsClass}/wizard`;
      } else {
        path = `/dashboard/${bsClass}/dashboard`;
      }
    }
    // This is used to redirect to dashbord sub-menu directly on click of this menu
    if (bsClass === "branding") {
      path = `/dashboard/${bsClass}/appbranding`;
    }
    // This is used to redirect to dashbord sub-menu directly on click of this menu
    if (bsClass === "analytics") {
      path = `/dashboard/${bsClass}/dashboard`;
    }
    // This is used to redirect to users or wizard sub-menu directly on click of this menu
    if (bsClass === "tickets") {
      path =
        this.props.ticketDashboard && this.props.ticketDashboard.setting
          ? `/dashboard/${bsClass}/appusers`
          : `/dashboard/${bsClass}/wizard`;
    }
    // This is used to redirect to course wizard sub-menu directly on click of this menu
    if (bsClass === "courses") {
      path = `/dashboard/${bsClass}/wizard`;
    }
    // This is used to redirect to dashbord sub-menu directly on click of this menu
    if (bsClass === "polls") {
      path = `/dashboard/${bsClass}/liveqa`;
    }
    if (bsClass === "gamification") {
      path = `/dashboard/${bsClass}/challenge`;
    }
    if (bsClass === "settings") {
      path = `/dashboard/${bsClass}/eventsetting`;
    } // This is used to redirect to dashbord sub-menu directly on click of this menu
    if (this.props.menuItem.bsClass !== "Logo") {
      this.props.selectDashboardMenu(this.props.menuItem);
      if (this.props.unsavedChanges) {
        this.props.onClickNext(path);
      } else {
        this.props.history.push(path);
      }
    }
  };

  revealAction = () => {
    //debugger;
    this.props.selectedRevealMenuIcon(this.props.menuItem);
  };

  render() {
    var { menuItem } = this.props;
    var normalIconUrl = `${NEW_IMAGE_PATH}side_menu_icons/${this.props.menuItem.bsClass}_black.png`;
    var selectedIconUrl = `${NEW_IMAGE_PATH}side_menu_icons/${this.props.menuItem.bsClass}_blue.png`;

    // Users icon used as Registration side menu icon
    if (this.props.menuItem.bsClass === "tickets") {
      normalIconUrl = `${NEW_IMAGE_PATH}side_menu_icons/users_black.png`;
      selectedIconUrl = `${NEW_IMAGE_PATH}side_menu_icons/users_blue.png`;
    }
    // =============== //

    if (this.props.menuItem.bsClass === "Logo") {
      normalIconUrl = `${NEW_IMAGE_PATH}side_menu_icons/${this.props.menuItem.bsClass}.png`;

      if (DEVELOPMENT_TYPE === "koachify") {
        normalIconUrl = `${NEW_IMAGE_PATH}side_menu_icons/koachify_logo.svg`;
      }
    }

    if (this.props.menuItem.bsClass === "Logo") {
      selectedIconUrl = normalIconUrl;
    }

    if (this.state.hovered) {
      normalIconUrl = selectedIconUrl;
    }

    var style = classNames("horizontal-align-center", "menuicon");

    var selectedClass = "";
    if (this.props.selected) {
      normalIconUrl = selectedIconUrl;
      selectedClass = "selected-side-menu";
    }

    var iconStyle = "menu-icon-title";
    if (this.props.menuItem.bsClass === "Logo") {
      style = "menuicon-logo";
      iconStyle = "no-menu-icon-title";
    }

    var hoverstyle = "";
    if (this.state.hovered) {
      hoverstyle = "hovered";
    }

    var showToolTip = true;

    if (
      this.props.menuItem.bsClass === "separatorbottom" ||
      this.props.menuItem.bsClass === "separatortop"
    ) {
      showToolTip = false;
      style = "horizontal-align-center";
    }

    var inlineStyle = {
      height: 53,
    };

    if (this.props.menuItem.bsClass === "Logo") {
      inlineStyle = {
        height: 71,
      };
    }

    // Error correction  code
    let li_height = 40;
    /*var li_height=40;

    if(this.props.selectedRevealIcon.bsClass === 'separatorbottom' && this.props.menuItem.bsClass === 'separatorbottom'){
      inlineStyle={
        height:0
      };
      li_height=0;
    }

    if(this.props.selectedRevealIcon.bsClass === 'separatorbottom' && this.props.menuItem.bsClass === 'separatortop'){
      inlineStyle={
        height:70
      };
    }

    if(this.props.selectedRevealIcon.bsClass === 'separatortop' && this.props.menuItem.bsClass === 'separatorbottom'){
      inlineStyle={
        height:70
      };
    }

    if(this.props.selectedRevealIcon.bsClass === 'separatortop' && this.props.menuItem.bsClass === 'separatortop'){
      inlineStyle={
        height:0
      };
      li_height=0;
    }*/

    return (
      <li
        className={`${style} ${hoverstyle}`}
        style={inlineStyle}
        onClick={showToolTip ? this.onMenuClick : this.revealAction}
      >
        {this.props.menuItem.bsClass === "Logo" ? (
          <img className="normal" src={normalIconUrl} />
        ) : showToolTip ? (
          <>
            <OverlayTrigger
              key={this.props.menuItem.bsClass}
              placement="right"
              overlay={
                <Tooltip
                  id={`tooltip-${this.props.menuItem.bsClass}`}
                  style={{ marginTop: "-5px" }}
                >
                  {this.props.menuItem.bsClass === "tickets"
                    ? "User Management"
                    : this.props.menuItem.iconName}
                </Tooltip>
              }
            >
              {({ ref, ...triggerHandler }) => (
                <>
                  <div
                    className="toolitp-btn"
                    style={{ borderColor: "#fff", height: 34 }}
                  >
                    <div className={`side-menu-icons ${selectedClass}`}>
                      {
                        AppIcons[
                          menuItem.bsClass === "tickets"
                            ? "users"
                            : menuItem.bsClass
                        ]
                      }
                    </div>{" "}
                    <span className="tooltiptext-menuicons">
                      {this.props.menuItem.bsClass === "tickets"
                        ? "User Management"
                        : this.props.menuItem.iconName}
                    </span>
                  </div>
                </>
              )}
            </OverlayTrigger>
          </>
        ) : (
          <div style={{ height: li_height }}></div>
        )}
      </li>
    );
  }
}

function mapStateToProps(state, ownProps) {
  var arr = _.split(ownProps.location.pathname, "/"); //Split the path array
  if (arr.length > 3) {
    //We don't need array content beyond 3rd element
    //so remove all others if available
    arr = _.dropRight(arr, arr.length - 3);
  }
  var pathName = _.last(arr);
  if (pathName === "dashboard" && arr.length === 2) {
    //if the path is just dashboard, General should be selected by default
    pathName = "general"; //First tab to be selected
  }

  return {
    selected: ownProps.menuItem.bsClass === pathName,
    unsavedChanges: state.unsavedChanges,
    selectedRevealIcon: state.selectedRevealMenu,
    ticketDashboard: state.ticketDashboard.data,
    session: state.session,
    siteDetails: state.siteDetails,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    selectDashboardMenu,
    showError,
    selectedRevealMenuIcon,
  })(MenuIcon)
);
